import React from "react"
import { AnimatePresence, motion, useReducedMotion } from "motion/react"

export default function PageTransition({ children, location }) {
  const reduceMotion = useReducedMotion()
  const path = location?.pathname || "page"

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={path}
        initial={reduceMotion ? false : { opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={reduceMotion ? undefined : { opacity: 0 }}
        transition={{
          duration: reduceMotion ? 0 : 0.24,
          ease: [0.22, 1, 0.36, 1],
        }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  )
}
